import React from 'react';
import OmniHistoriesMessageBox from './OmniHistoriesMessageBox';
import { useOmniHistoriesManageContext } from 'contexts';
import { LeftIcon } from 'assets';
import { Button, Typography } from 'antd';

type Props = {};
const OmniChannelChatHistoriesChat: React.FC<Props> = () => {
  const { chatSession, setChatSession } = useOmniHistoriesManageContext();

  const handleBack = () => {
    setChatSession(undefined);
  };

  return (
    <div className='flex h-full w-full flex-col'>
      <div className='relative flex h-14 items-center border-b px-4'>
        <div className='flex items-center gap-2'>
          <Button shape='circle' type='text' icon={<LeftIcon />} onClick={handleBack} />
          <div className='flex flex-col gap-0.5'>
            <Typography.Text className='text-sm font-semibold'>{chatSession?.chat.customerName}</Typography.Text>
            <Typography.Text className='text-xs'>{chatSession?.chat.source}</Typography.Text>
          </div>
        </div>
      </div>
      <div className='flex h-[calc(100%-52px)] flex-col bg-[#04A77D]'>
        <OmniHistoriesMessageBox />
      </div>
    </div>
  );
};
export default OmniChannelChatHistoriesChat;
